module.exports = __webpack_public_path__ + "img/334.fa7ef196.gif";